import styled from "styled-components";
import beAReseller from "assets/supergasbras/images/beAReseller.jpeg";
import { Link } from "react-router-dom";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  .css-1nxtzl-MuiGrid-root > .MuiGrid-item {
    padding-top: 0;
  }
`;

export const ContainerBackground = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  background-image: url(${beAReseller});
  background-position: top right;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const ArrowContainer = styled.div`
  display: flex;
  align-items: center;

  > svg {
    cursor: pointer;
  }
`;

export const LinkContainer = styled(Link)`
  color: ${({ theme }) => theme.palette.text.primary};
`;
